import http from './http-util'
import config from '../../../config'

class BonusCheckServiceApi {
  static hasBonusCheckSupport = token => {
    return http.get(
      token,
      `${config.bonusCheckServiceUrl}/has_bonus_check_support`,
    )
  }

  static getBonusChecks = (governmentId, customerType) => token => {
    return http.get(
      token,
      `${config.bonusCheckServiceUrl}/government_id/${governmentId}/customer_type/${customerType}`,
    )
  }

  static getBonusCheck = referenceNumber => token => {
    return http.get(
      token,
      `${config.bonusCheckServiceUrl}/reference/${referenceNumber}`,
    )
  }

  static redeemBonusCheck =
    (governmentId, customerType, reference) => token => {
      return http.put(
        token,
        `${config.bonusCheckServiceUrl}/government_id/${governmentId}/customer_type/${customerType}/reference/${reference}/redeem`,
      )
    }

  static redeemBonusCheckByReferenceNumber = referenceNumber => token => {
    return http.put(
      token,
      `${config.bonusCheckServiceUrl}/reference/${referenceNumber}/redeem`,
    )
  }
}

export default BonusCheckServiceApi
